module.exports = __webpack_public_path__ + "static/media/top_logo.d1843e02.png";